'use strict';

import { projectMode } from '../../../../settings';
import { createHtmlElement } from '../../../../functions';
import { Switch } from '../../../interfaces/switchers/Switch';
import { Range } from '../../../interfaces/switchers/Range';
import gsap from 'gsap';
import { changeLangToCurrent } from '../../../components/langSwitcher/langSwitcher';
import { Time } from '../../../projectTime/Time';
import { BaseElement } from '../../../interfaces/BaseElement';

export class TimesOfDay extends Time {
     static #ready = false;
     static active = Boolean(config.features.liteMode?.active && config.features.liteMode?.images.night);
     // #currentTime = 0;
     // #startTimeLine = 0;
     // #endTimeLine = 0;
     // #sunrise = 0;
     // #beforeSunrise = 0;
     // #afterSunrise = 0;
     // #sunset = 0;
     // #beforeSunset = 0;
     // #afterSunset = 0;
     // #switcher = null;
     // #range = null;
     // #currentTimeUse = true;
     // #shaderValue = 0.0;
     // #api = config.features.weather?.api; // the source of api is obsolete
     // #apiUrl = `${this.#api.domain}?lat=${config.localization.latitude}&lon=${config.localization.longitude}&units=${this.#api.units}&appid=${this.#api.id}`;

    constructor (parent,response) {
        super(response);

        //if (!this.#active) return;
        //this.#time = new Date(utc + (1000*Weather.#weatherData.timezone));
        this.parent = parent;
        this.response = response;
        this.currentTime = 0;
        this.switcher = null;
        this.range = null;
        this.currentTimeUse = true;
        this.switcherState = null;
        this.shaderValue = 0.0;
        this.blockSwitcher = false;

        // console.log('start', this.#startTimeLine);
        // console.log('sunrise', this.#sunrise);
        // console.log('sunset', this.#sunset);
        // console.log('end', this.#endTimeLine);
        //this.#preData();

        this.create();
    }

    // async #preData() {
    //   const response = await axios.get(this.#apiUrl);
    //   if (response.status !== 200) return;
    //   this.data = await response.data;
    //
    //   const d = new Date();
    //   const utc = d.getTime() + (d.getTimezoneOffset() * 60000);
    //
    //   const TIME_THRESHOLD = 2;
    //   const oneHour = 3600000;
    //
    //   const sunriseTime = new Date(this.data.sys.sunrise * 1000);
    //   const sunsetTime = new Date(this.data.sys.sunset * 1000);
    //
    //   this.#currentTime = new Date(utc + (1000*Weather.weatherData.timezone)).getTime();
    //   this.#startTimeLine = new Date(this.#currentTime).setHours(0,0,0,0);
    //   this.#sunrise = sunriseTime.getTime() + (sunriseTime.getTimezoneOffset() * 60000) + this.data.timezone * 1000;
    //   this.#beforeSunrise = this.#sunrise - TIME_THRESHOLD * oneHour;
    //   this.#afterSunrise = this.#sunrise + TIME_THRESHOLD * oneHour;
    //   this.#sunset = sunsetTime.getTime() + (sunsetTime.getTimezoneOffset() * 60000) + this.data.timezone * 1000;
    //   this.#beforeSunset = this.#sunset - TIME_THRESHOLD * oneHour;
    //   this.#afterSunset = this.#sunset + TIME_THRESHOLD * oneHour;
    //   this.#endTimeLine = new Date(this.#currentTime).setHours(23,59,59,0);
    // }

     create() {
        //if (!this.#active) return;
        // const response = await axios.get(this.#apiUrl);
        // if (response.status !== 200) return;
        // this.data = await response.data;

        // const d = new Date();
        // const utc = d.getTime() + (d.getTimezoneOffset() * 60000);
        //
        // const TIME_THRESHOLD = 2;
        // const oneHour = 3600000;
        //
        // let sunriseTime = new Date(this.data.sys.sunrise * 1000);
        // let sunsetTime = new Date(this.data.sys.sunset * 1000);
        //
        this.currentTime = this.getDayTimeLine().currentTime;
        // this.#startTimeLine = new Date(this.#currentTime).setHours(0,0,0,0);
        // this.#sunrise = sunriseTime.getTime() + (sunriseTime.getTimezoneOffset() * 60000) + this.data.timezone * 1000;
        // this.#beforeSunrise = this.#sunrise - TIME_THRESHOLD * oneHour;
        // this.#afterSunrise = this.#sunrise + TIME_THRESHOLD * oneHour;
        // this.#sunset = sunsetTime.getTime() + (sunsetTime.getTimezoneOffset() * 60000) + this.data.timezone * 1000;
        // this.#beforeSunset = this.#sunset - TIME_THRESHOLD * oneHour;
        // this.#afterSunset = this.#sunset + TIME_THRESHOLD * oneHour;
        // this.#endTimeLine = new Date(this.#currentTime).setHours(23,59,59,0);

         const {
             dayStart,
             beforeSunrise,
             sunrise,
             afterSunrise,
             beforeSunset,
             sunset,
             afterSunset,
             dayEnd
         } = this.getDayTimeLine();


        this.currentTimeMainContainer = createHtmlElement(this.parent,'','div',['current-time__container','display-option']);
        const currentTimeToggle = createHtmlElement(this.currentTimeMainContainer,'','div',['current-time__toggle']);
        const currentTimeToggleText = createHtmlElement(currentTimeToggle,changeLangToCurrent('Current time lighting'),'span',['current-time__toggle__text','language-string']);
        currentTimeToggleText.setAttribute('data-dictionary','Current time lighting');

        this.switcher = new Switch(currentTimeToggle);
        this.switcher.checked = true;
        this.switcherState = true;
        this.switcher.listener = this.#switcherHandler.bind(this);

        this.range = new Range(this.currentTimeMainContainer,dayStart,dayEnd,1000,this.currentTime);
        this.range.element.classList.add('current-time__range');
        this.range.element.setAttribute('id','currentTime');
        this.range.addListener('input',(e) => this.updateTimesOfDay(undefined,e.target.value));
        this.range.addListener('mousedown', this.#turnOffSwitcher.bind(this));
        this.range.addListener('touchstart', this.#turnOffSwitcher.bind(this));
        this.rangeOutput = new BaseElement('output')
            .addClass('current-time__output')
            .addAttribute('for','currentTime')
            .appendTo(this.range.rangeContainer);
        this.rangeOutputTime = new Date();


        const sunriseTime = new Date(sunrise);
        const sunsetTime = new Date(sunset);
        const sunriseMinutes = sunriseTime.getMinutes() < 10 ? `0${sunriseTime.getMinutes()}` : sunriseTime.getMinutes();
        const sunsetMinutes = sunsetTime.getMinutes() < 10 ? `0${sunsetTime.getMinutes()}` : sunsetTime.getMinutes();

        const timeContainer = createHtmlElement(this.currentTimeMainContainer,'','div',['current-time__time-container']);
        const outputSunrise = createHtmlElement(timeContainer,`${sunriseTime.getHours()}:${sunriseMinutes}`,'span',['current-time__bubble','sunrise','icon-dawn']);
        const sunriseArrowUp = createHtmlElement(outputSunrise,'','span',['sunrise','icon-up1','current-time__sun-arrow']);

        this.#createSunMarker(outputSunrise,sunrise,17);
        const outputSunset = createHtmlElement(timeContainer,`${sunsetTime.getHours()}:${sunsetMinutes}`,'span',['current-time__bubble','sunset','icon-dawn']);
        const sunsetArrowDown = createHtmlElement(outputSunset,'','span',['sunset','icon-down1','current-time__sun-arrow','sunset-arrow']);

        this.#createSunMarker(outputSunset,sunset,8);

        const event = new Event('change');
        this.switcher.checkbox.dispatchEvent(event);
        TimesOfDay.#ready = true;
    }

    showCurrentTimeBubble() {
        const val = this.range.element.value;
        this.rangeOutputTime.setTime(val);
        const hours = this.rangeOutputTime.getHours();
        const minutes = this.rangeOutputTime.getMinutes() < '10' ? `0${this.rangeOutputTime.getMinutes()}` : this.rangeOutputTime.getMinutes();
        const min = this.range.element.min;
        const max = this.range.element.max;
        this.rangeOutput.innerHtml(`${hours}:${minutes}`);
        const position = Number(((val - min) * 100) / (max - min));
        this.rangeOutput.DOMElement.style.left =  `calc(${position}% + (${8 - position * 0.2}px))`;
    }

    removeFromDisplayOptions() {
        this.switcher = null;
        this.range = null;
        this.currentTimeMainContainer.remove();
    }

     #createSunMarker(marker, value, correction) {
        const min = this.range.element.min;
        const max = this.range.element.max;
        const markerValue = Number(((value - min) * 100) / (max - min));
        const position = correction - (markerValue * 0.2);
        marker.style.left = `calc(${markerValue}% + (${position}px))`;
    }

    #turnOffSwitcher() {

        if (this.range.element.classList.contains('disabled')){
            this.switcher.checked = false;
            const event = new Event('change');
            this.switcher.checkbox.dispatchEvent(event);
        }
    }

     #switcherHandler(e) {
        if (!TimesOfDay.active) return;

         if (this.blockSwitcher) {
             this.switcher.checkbox.checked = this.switcherState;
             return;
         }

        this.switcherState = e.target.checked;
        switch (this.switcherState) {
            case true:
                const time = {value: Number(this.range.element.value)};

                gsap.to(time,{
                    value: this.currentTime,
                    duration: .7,
                    onStart: () => {
                        this.blockSwitcher = true;
                        this.currentTimeToggle(false);
                        this.range.classToggle('disabled');
                    },
                    onUpdate: () => {
                        this.updateTimesOfDay(undefined, time.value);
                    },
                    onComplete: () => {
                        this.blockSwitcher = false;
                        this.currentTimeToggle(true);
                    }
                });

                break;
            case false:
                this.range.classToggle('disabled');
                this.currentTimeToggle(false);
                break;
        }
    }

    refreshTime() {
        if (!TimesOfDay.active)
            return;

        this.currentTimeToggle() && this.updateTimesOfDay(this.getCurrentTimeMilliseconds);
    }


     updateTimesOfDay(time, manualTime) {
        if (!TimesOfDay.active)
          return;

        let currentTime;

        if (manualTime) {
            currentTime = Number(manualTime);
        } else {
            currentTime = time;
            this.currentTime = currentTime;
        }

        let from, to, timeFrom, timeTo, totalTime, timePast, ndcValue = undefined;

         const {
             beforeSunrise,
             afterSunrise,
             beforeSunset,
             afterSunset
         } = this.getDayTimeLine();


        if (currentTime <= beforeSunrise){
            ndcValue = 1.0;
        } else if (currentTime >= beforeSunrise && currentTime <= afterSunrise) {
            from = 1.0;
            to = 0;
            timeFrom = beforeSunrise;
            timeTo = afterSunrise;
        } else if (currentTime >= afterSunrise && currentTime <= beforeSunset){
            ndcValue = 0;
        } else if (currentTime >= beforeSunset && currentTime <= afterSunset) {
            from = 0;
            to = 1.0;
            timeFrom = beforeSunset;
            timeTo = afterSunset;
        } else {
            ndcValue = 1.0;
        }

        if (ndcValue !== undefined) {
            this.shaderValue = ndcValue;
        } else {

            totalTime = timeTo - timeFrom;
            timePast = currentTime - timeFrom;
            ndcValue = timePast / totalTime;

            if (from > to){
                this.shaderValue = from - ndcValue;
            } else {
                this.shaderValue = ndcValue
            }
        }

        this.#setTime(this.shaderValue,currentTime);
    }

     #setTime(value,rangeValue) {

        projectMode.LiteMode.sea.updateTimesOfDay(value);
        projectMode.LiteMode.trees.updateTimesOfDay(value);
        projectMode.LiteMode.sky.updateTimesOfDay(value);
        projectMode.LiteMode.plug.updateTimesOfDay(value);
        projectMode.LiteMode.updateTimesOfDay(value);

        this.range.element.value = rangeValue;
        this.showCurrentTimeBubble();
    }

    currentTimeToggle(value) {
       // if (!TimesOfDay.active) return;
        if (value === undefined) return this.currentTimeUse;

        this.currentTimeUse = value;
    }

    static isReady() {
        return TimesOfDay.#ready;
    }

    get isActive() {
      return TimesOfDay.active;
    }

}
